import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
// import
axios.defaults.baseURL = '/api';

//http request 拦截器
// 响应拦截
axios.interceptors.response.use(function (response) {
//   // response.data.status = response.status || "";
//   // if (!response.data.msg && response.data.code == 1) {
//   //   response.data.msg = "服务端发生异常"
//   // }
  return response.data
}, error => {
//   console.log(error);
//   // 判断状态
//   if (error.response.status === 401) {
//     // val++
//     // var d = new Date();
//     // d.setDate(d.getDate() * 1 - 1);
//     // document.cookie = "userInfo" + "=" + encodeURIComponent(JSON.stringify("")) + ";expires=" + d.toGMTString();
//     error.response.data.msg = "登录过期"
//     router.replace({
//         name: 'Login',
//     })
//     return error.response.data;
//   }
//   // if (!error.response.data.msg) {
//   //   error.response.data.msg = "服务端发生异常"
//   // }
//   // error.response.data.status = error.response.status || "";
//   // return Promise.reject(error.response.data);
  return error.response.data
})

// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
/**
 * GET请求封装
 *
 * */
Vue.prototype.$get = function (url, data, fun, err, man_id = '') { //url接口 data 传入数据 fun 成功方法 err 错误方法
  axios({
    method: 'get',
    url: url,
    headers: {
      // 'Authentication': localStorage.getItem("token"),
      id: man_id
    },
    params: data,
  }).then(function (res) {
    if (fun) {
      fun(res)
    }
  }).catch(function (error) {
    if (err) {
      err(error)
    }
  });
}
/**
 * POST请求封装
 *
 * */
Vue.prototype.$post = function (url, data, fun, err) {
  axios({
    method: 'post',
    url: url,
    headers: {
      // 'Authentication': localStorage.getItem("token"),
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Headers': 'Origin,X-Requested-With,Content-Type,Accept,Authorization,sourcetype,token',
      'Access-Control-Allow-Methods': 'POST,GET,PUT,OPTIONS,DELETE'
    },
    data: qs.stringify(data)
  }).then(function (res) {
    if (fun) {
      fun(res)
    }
  }).catch(function (error) {
    if (err) {
      err(error)
    }
  });
}
/**
 * 修改请求封装
 *
 * */
Vue.prototype.$put = function (url, data, fun, err) {
  axios({
    method: 'put',
    url: url,
    headers: {
      // 'Authorization': userName ? userName.token_type + userName.access_token : "Basic emh4eTp6aHh5",
      // 'Authentication': localStorage.getItem("token"),
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: data
  }).then(function (res) {
    if (fun) {
      fun(res)
    }
  })
    .catch(function (error) {
      if (err) {
        err(error)
      }
    });
}
/**
 * 删除请求封装
 * 
 * */
Vue.prototype.$delete = function (url, data, fun, err, isbody) {
  axios({
    method: 'delete',
    url: url,
    headers: {
      // 'Authentication': localStorage.getItem("token"),
    },
    data: data
  }).then(function (res) {
    if (fun) {
      fun(res)
    }
  })
    .catch(function (error) {
      if (err) {
        err(error)
      }
    });
}

/**
 * 登录POST请求封装
 *
 * */
Vue.prototype.$loginpost = function (url, data, fun, err) {
  axios({
    method: 'post',
    url: url,
    data: data
  }).then(function (res) {
    if (fun) {
      fun(res)
    }
  }).catch(function (error) {
    if (err) {
      err(error)
    }
  });
}

/**
 * 导出
 *
 * */
Vue.prototype.$postExport = function (url, data, fun, err) {
  axios({
    method: 'post',
    url: url,
    responseType: "blob",
    headers: {
      // 'Authentication': localStorage.getItem("token"),
      'Content-Type': 'application/octet-stream'
    },
    params: data
  }).then(function (res) {
    if (fun) {
      fun(res)
    }
  }).catch(function (error) {
    if (err) {
      err(error)
    }
  });
}